import styled, { css } from 'styled-components'
import { Input, FormFeedback } from 'reactstrap'

import { COLOURS } from 'resources'

const ACTIVE_LABEL_FONT_SIZE = 16
const ACTIVE_LABEL_LINE_HEIGHT = 22
const INPUT_VERTICAL_PADDING = 8

export const InputWrapper = styled.div`
  position: relative;
`

export const LabelSpacing = styled.div`
  height: ${ACTIVE_LABEL_LINE_HEIGHT}px;
`

const ActiveLabelStyle = css`
  top: 0;
  font-size: ${ACTIVE_LABEL_FONT_SIZE}px;
  line-height: ${ACTIVE_LABEL_LINE_HEIGHT}px;
  color: ${COLOURS.neutralGrey4};
`

const InputTextStyle = css`
  font-size: 18px;
  line-height: 24px;
`

export const InputLabel = styled.label`
  ${InputTextStyle}
  color: ${COLOURS.neutralBlack};
  margin: 0;
  padding: inherit;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  top: ${ACTIVE_LABEL_LINE_HEIGHT + INPUT_VERTICAL_PADDING}px;
  transition: 300ms ease all;
  left: 0;
  &.has-icon {
    left: 30px;
  }

  ${(props) => props.hasValue && ActiveLabelStyle}
`

export const IconContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: ${INPUT_VERTICAL_PADDING}px;
  padding: inherit;
`

export const KilliIcon = styled.i`
  font-size: 24px;
  line-height: 1;
  color: ${COLOURS.neutralBlack};

  &::before {
    margin: 0;
  }
`

/**
 * @type Input
 */
export const BaseInput = styled(Input)`
  ${InputTextStyle}
  background: none;
  height: auto;
  color: ${COLOURS.neutralBlack};
  padding: ${INPUT_VERTICAL_PADDING}px 0;
  border: none;
  border-bottom: 2px solid ${COLOURS.neutralBlack};
  border-radius: 0;

  &.has-icon {
    padding-left: 30px;
  }

  &:disabled {
    background: none;
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:invalid,
  &.is-invalid {
    background-image: none;
    padding-right: 0;
    border-color: ${COLOURS.secondaryRed1};

    :focus {
      box-shadow: none;
      border-color: ${COLOURS.secondaryRed1};
    }
  }

  &:not(:disabled):focus {
    outline: none;
    box-shadow: none;
    background: none;
    border-bottom-color: ${COLOURS.secondaryPurple1};
    color: ${COLOURS.neutralBlack};

    ~ ${InputLabel} {
      ${ActiveLabelStyle}
      color: ${COLOURS.secondaryPurple1};
    }
  }
`

export const ErrorMessage = styled(FormFeedback)`
  font-size: 16px;
  line-height: 22px;
  color: ${COLOURS.secondaryRed1};
`
